﻿/* global _, datesObject, angular, analytics_data */
import { analyticsEvent } from '../../controllers/analytics-controller';
var InformaFacetController = function ($scope, $rootScope, $location, $http, $anchorScroll, $timeout,  searchService, searchBootstrapper, facetAvailabilityService) {
    "use strict";
    // Bind `this` to vm - a representation of the view model
    var vm = this;
    // General Facet stuff
    vm.facetGroups = searchService.getFacetGroups();
    vm.searchService = searchService;
    vm.location = $location;
    vm.anchorScroll = $anchorScroll;
    vm.searchBootstrapper = searchBootstrapper;
    vm.MaxFacetShow = 5;
    vm.SecondLevelMaxFacetShow = 3;
    vm.showingOnlySubscriptions = false;
    vm.subscriber_cookie;
    vm.subscriptions;
    vm.enableMySusbriptions = false;
    vm.keywordSearch = false;
    vm.companies = { "companies": "", "isCompanySelected": false };
    vm.defaultState = true;
    vm.themeOmdia = angular.element(document.body).hasClass('theme-omdia');
    vm.themeChemistAndDruggist = angular.element(document.body).hasClass('theme-chemistanddruggist');
    vm.clearAllVisible = false;
    vm.facetWithShowMore = [];
    vm.subFacetWithShowMore = [];
    vm.allSubFacetSelected = false;
    vm.ParentFacetId = '';
    vm.selectedFilters = [];
    vm.defaultExpandedRefinements = jQuery('#defaultExpandedRefinements').val();
    
	$rootScope.$watch('facetAvailability', function () {
        vm.areFacetsDisabled = facetAvailabilityService.facetsAreEnabled();
    });

    vm.searchType = '';
    $scope.$watch(function () {
        return vm.searchService.getSearchType();
    }, function () {
        vm.searchType = vm.searchService.getSearchType();
        if (vm.searchType=="product") {
            vm.defaultExpandedRefinements = jQuery('#defaultExpandedRefinementsProduct').val();
        }
    });

    vm.facetgroupState = {};
    // Date Facet stuff
    vm.DateFilters = [
        { label: 'All', key: 'all', selected: true },
        { label: 'Last 24 hours', key: 'day', selected: false },
        { label: 'Last 3 days', key: 'threedays', selected: false },
        { label: 'Last week', key: 'week', selected: false },
        { label: 'Last month', key: 'month', selected: false },
        { label: 'Last year', key: 'year', selected: false },
        { label: 'Select date range', key: 'custom', selected: false }
    ];

    vm.originalGroup = [];
    var dToday = function () {
        return new Date().clearTime();
    };

    var jsDates = {
        minus1Year: function () {
            var jsDateToday = new Date();
            return new Date(jsDateToday.setFullYear(jsDateToday.getFullYear() - 1));
        },
        minus1Month: function () {
            var jsDateToday = new Date();
            var m = jsDateToday.getMonth();
            jsDateToday.setMonth(jsDateToday.getMonth() - 1);

            // If still in same month, set date to last day of previous month
            if (jsDateToday.getMonth() == m) {
                jsDateToday.setDate(0);
            }
            return new Date(jsDateToday.setHours(0, 0, 0));
        },
        minusXdays: function (days) {
            var jsDateToday = new Date();
            return new Date(jsDateToday.setDate(jsDateToday.getDate() - days));
        }
    };

    var formatDateObject = function (d) {
        return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
    };

    vm.datesObject = {
        year: formatDateObject(jsDates.minus1Year()),
        day: formatDateObject(jsDates.minusXdays(1)),
        threedays: formatDateObject(jsDates.minusXdays(3)),
        month: formatDateObject(jsDates.minus1Month()),
        week: formatDateObject(jsDates.minusXdays(7))
    };

    vm.timesObject = {
        year: { id: "year", value: "1" },
        day: { id: "hour", value: "24" },
        threedays: { id: "day", value: "3" },
        month: { id: "month", value: "1" },
        week: { id: "week", value: "1" }
    };

    // Create placeholder values for From: and To: date values
    $scope.dateValues = {
        dtFrom: '',
        dtTo: ''
    };

    // need to differentiate the 2 datepickers
    $scope.datepickers = {
        dtFrom: false,
        dtTo: false
    };

    // On first run, check all date filters against date filter set in URL
    for (var i = 0; i < vm.DateFilters.length; i++) {
        if ($location.search().dateFilterLabel == vm.DateFilters[i].key) {
            // Mark date filter as selected to match URL
            vm.DateFilters[i].selected = true;
            // If date filter is a date range filter...
            if (vm.DateFilters[i].key === 'custom') {
                // ...convert the date data in the URL to `Date`s...
                // example: date=3/29/2015;4/5/2016
                var splitDates = $location.search().date.split(';');
                // ...and update the model so the UI shows the right data.
                $scope.dateValues.dtFrom = new Date(splitDates[0]);
                $scope.dateValues.dtTo = new Date(splitDates[1]);
            }
        }
    }

    $scope.$watch(
        function () {
        return searchService.getPager();
    }, function () {
        vm.facetGroups = searchService.getFacetGroups();
        if(vm.themeOmdia) {
            _.each(vm.facetGroups, function(facetList) {
                if(vm.facetWithShowMore.includes(facetList.id)) {
                    facetList.ShowMore = true;
                }
            });

            vm.facetWithShowMore = [];        
            _.each(vm.facetGroups.facets, function(facetList) {
                if(vm.SubFacetWithShowMore.includes(facetList.id)) {
                    facetList.ShowMore = true;
                }
            });

            vm.SubFacetWithShowMore = [];
            if (vm.allSubFacetSelected) {
                vm.facetChange(vm.ParentFacetId);
            }            
            vm.clearAllSetFlag();
        }

        vm.originalGroup = vm.searchService.getFacetGroups();
        if (searchService.getNewSearch()) {
            vm.facetGroups = vm.originalGroup;
            //vm.clearAllFacets();
            searchService._isNewSearch = false;
        }
    }, true);

    $scope.$watch(function () {
      return vm.location.url();
    }, function () {
        var url = vm.location.url().substr(0, vm.location.url().indexOf('#searchTop')),
            urlStr = url.length > 0 ? '#' + url : '';            
        try {
            ga('send', 'pageview', '/search'+ urlStr);
            console.log("ga('send', 'pageview', '/search"+ urlStr + "')");
        } catch (error) {
            console.warn("ga undefined event not tracked", "ga('send', 'pageview', '/search"+ urlStr + "')");
        }
    }, true);

    vm.createCookie = function (name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
    };

    vm.readCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    };

    vm.updateCookie = function (facetParentId = null) {
        if (vm.subscriptions.length > 0) {
            var subscriptionId = 'publication', issubscriptionChannel = false;;
            _.each(vm.subscriptions, function (channel) {
                var splitName = channel.split("-");
                if (splitName.length > 1) {
                    subscriptionId = splitName[0];
                }
                if (facetParentId == subscriptionId.replace(" ", "").replace("'", "").toLowerCase()) {
                    issubscriptionChannel = true;
                }
            });

            if (issubscriptionChannel) {
                var cookie_facets = [];
                _.each(vm.facetGroups, function (group) {
                    _.each(group.getSelectedFacets(), function (facet) {
                        if (facet && facet.selected) {
                            if (facet.parentId == "publication" && cookie_facets.indexOf(facet.label) === -1) {
                                cookie_facets.push(facet.label.toLowerCase());
                            } else if (facet.parentId != "publication" && cookie_facets.indexOf(facet.parentId + '-' + facet.label) === -1) {
                                var isSubscriber = false;
                                _.each(vm.subscriptions, function (channel) {
                                    var splitName = channel.split("-");
                                    if (splitName.length > 1) {
                                        subscriptionId = splitName[0];
                                    }
                                    if (facet.parentId == subscriptionId.replace(" ", "").replace("'", "").toLowerCase()) {
                                        isSubscriber = true;
                                    }
                                });
                                if (isSubscriber)
                                    cookie_facets.push(facet.parentId + '-' + facet.label);
                            }
                        }
                    });
                });

                if (cookie_facets.length > 0 && vm.enableMySusbriptions && vm.keywordSearch) {
                    vm.createCookie(vm.subscriber_cookie, cookie_facets, 3650);
                }
            }
        }
    };
    
    jQuery(window).on('load', function () {
        var subscriberList = vm.subscriptions;
        // if(subscriberList) subscriberList = JSON.parse(subscriberList);
        var userName = jQuery('#userName').val();
        vm.enableMySusbriptions = (jQuery('#enableMySusbriptions').val() == "true") ? true : false;
        var queryStrings = window.location.href.split('?')[1];
        if (!queryStrings) return;
        var queryString = queryStrings.split('&');
        var searchQuery = queryString[0].split('=');
        if (searchQuery[0] == "q") {
            vm.keywordSearch = true;
        }
        if (userName) {
            var cookieNameId = userName.split("@");
            if (cookieNameId[0]) {
                vm.subscriber_cookie = "subscriptions" + window.btoa(cookieNameId[0]);
                vm.subscriber_cookie = vm.subscriber_cookie.replace(/=/g, '');
                if (vm.enableMySusbriptions && vm.keywordSearch) {
                    vm.showingOnlySubscriptions = true;
                    if (vm.readCookie(vm.subscriber_cookie)) {
                        var cookie = JSON.parse(vm.readCookie(vm.subscriber_cookie));
                        if (cookie.length == 0)
                            vm.showingOnlySubscriptions = false;
                        else
                            vm.facetChangeMultiple('publication', cookie);
                    }
                    else if (subscriberList && subscriberList.length > 0)
                        vm.facetChangeMultiple('publication', subscriberList);
                }
            }
        }
    });

    if (vm.themeOmdia) {
      $scope.$watch(function() {
        return searchService.getFacetGroups();
      }, function () {
        vm.rebuildSelectedFilters();
        vm.setSearchPlaceholder();
      }, true);
    }

    vm.setSearchPlaceholder = function() {
        if (vm.selectedFilters.length > 0) {
            if(vm.selectedFilters.length === 1 && vm.selectedFilters[0].name) {
                $rootScope.searchPlaceholder = 'Search within "' + vm.selectedFilters[0].name + '"';
            } else {
                $rootScope.searchPlaceholder = 'Search within selected filters';
            }
        } else {
            $rootScope.searchPlaceholder = 'Search all content';
        }
    }

    vm.rebuildSelectedFilters = function() {
        vm.selectedFilters = [];
        vm.addFacetsToSelecterFilters();
    }   

    vm.addFacetsToSelecterFilters = function () {
        var searchParams = vm.location.search(),
            selectedFilter,
            facetGroup,
            values

        _.forIn(searchParams, function(value, key) {
            selectedFilter = {};
            selectedFilter.query = key;

            // skip if param not facet or taxonomy
            switch(key) {
            case 'q':
            case 'page':
            case 'perPage':
            case 'searchtype':
            case 'showFreecontent':
            case 'sortBy':
            case 'sortOrder':
            case 'time':
            case 'date':
                return true;            
            case 'headlinesOnly':
            case 'entitledcontentonly':
            case 'exactmatchonly':
                selectedFilter.name = $("label.search-bar__headline-label[for='"+ key +"']").html();                
            case 'dateFilterLabel':
                switch (value) {
                case 'hour':
                case 'day':
                case 'week':
                case 'month':
                case 'year':
                    var time = parseInt(searchParams.time);
                    selectedFilter.name = 'Last ' + time + ' ' + value + (time > 1 ? 's' : '');
                    break;
                case 'custom':
                    var customDateArray = searchParams.date.split(';'),
                        startStr = new Date(decodeURIComponent(customDateArray[0])).toLocaleDateString('en-GB'),
                        endStr = new Date(decodeURIComponent(customDateArray[1])).toLocaleDateString('en-GB');
                        selectedFilter.name = startStr == endStr ? startStr : (startStr + ' - ' + endStr);
                }
                break;
            default:
                // facet or custom query
                facetGroup = vm.searchService.getFacetGroup(key);        
                // is facet
                if (facetGroup) {
                    values = value.split(';');
                    // when there are 2 or more facets
                    if (values.length > 1) {
                        // the name should be the FacetGroup name
                        selectedFilter.name = facetGroup.label;
                        // the count property should be defined
                        selectedFilter.count = values.length;
                    } else {
                        // if there's only one value then assume facet
                        selectedFilter.name = value;
                    }
                } else {
                    // not a facet group, so assume taxonomy / custom query
                    selectedFilter.name = value;
                }
            }
            vm.selectedFilters.push(selectedFilter);
        });
    }

    vm.removeParamFromSearch = function(param) {
        if (param === 'dateFilterLabel') {
            delete vm.location.search()['date'];
            delete vm.location.search()['time'];
        }
        if (param === 'exactmatchonly') {
            vm.location.search().q = vm.location.search().q.replace(/['"]+/g, '');
        }
        delete vm.location.search()[param];
    }

    vm.updateFilters = function() {
        var newSearchObj = vm.location.search(),
            searchStr = Object.keys(newSearchObj).map(function(key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(newSearchObj[key])
            }).join('&');

        window.INFORMA.Spinner.Show(jQuery('body'));

        if (searchStr.length === 0) {
            searchStr = "#?page=1&sortBy=relevance&sortOrder=desc#searchTop";
        } else {
            searchStr = '#?' + searchStr + '#searchTop';
        }
               
        // clean fix: need to update facets
        window.location.assign(window.location.origin + window.location.pathname + searchStr);
        window.location.reload();
    }

    vm.clearSelectedFilter = function(filter) {
        vm.removeParamFromSearch(filter.query);
        vm.updateFilters();
    }

    vm.clearAllSelectedFilters = function() {
        _.each(vm.selectedFilters, function(selectedFilter) {
            vm.removeParamFromSearch(selectedFilter.query);
        });
        vm.updateFilters();
    }

    //** This collects the user's saved companies **//
    vm.savedCompanies = {};
    vm.saveCompany = function ($item, model, label) {
        vm.savedCompanies[$item] = {
            selected: true,
            label: $item
        };
    };

    $scope.removeCompany = function ($item, model, label) {
        delete $scope.savedCompanies[$item.label];
    };

	var facetsForAnalytics = false;
    //** This updates the router/url with the latest search parameters **//
    vm.update = function (facetGroupId) {
        if(facetGroupId) {
            var facetGroup;
                facetsForAnalytics = false;

            _.each(vm.facetGroups, function(group) {
                if(group.id === facetGroupId) {
                    facetGroup = group;
                }
            });

            _.each(facetGroup.getSelectedFacets(), function (facet) {
                if(facet) {
                    if(!facetsForAnalytics) {
                        facetsForAnalytics = facet.label;
                    } else {
                        facetsForAnalytics += '|' + facet.label;
                    }
                }
            });
            
            var event_data = {
                event_name: 'search_facets',
                search_facet_category: facetGroup.label
            };

            if(facetsForAnalytics) {
                event_data.search_facet = facetGroup.label + ": " + facetsForAnalytics;
            }

            analyticsEvent(	$.extend(analytics_data, event_data) );
        } 
		
        // Disable all facet options while updating search results
        facetAvailabilityService.disableFacets();
        vm.updateFacetToggleState();
        vm.allRegionsFacetsSelected();

        var params = this.searchService.getRouteBuilder().getRoute().split('&');
        if (this.searchService.getRouteBuilder().getRoute().indexOf("companies") >= 0) {
            for (var idx_param in params) {
                if (params[idx_param].indexOf("companies") >= 0) {
                    var compValue = params[idx_param].split('=')[1];
                    vm.companies["isCompanySelected"] = true;
                    vm.companies["companies"] = compValue;
                }
            }
        } else {
            vm.companies["isCompanySelected"] = false;
            vm.companies["companies"] = "";
        }

        // reapplies facet selected status to resolve issue raised in ISW-5988
        // TODO: to investigate actual cause of default func not working as expected
        _.each(this.facetGroups, function(group) {
            _.each(group.facets, function(facet) {
                _.each(facet.sublist, function(subfacet) {
                    vm.searchService.getFacet(subfacet.id).selected = subfacet.selected;
                });
            });
        });

        vm.searchService.getFilter('page').setValue('1');
        var routeBuilder = this.searchService.getRouteBuilder();
        vm.location.search(routeBuilder.getRoute());
        vm.searchService.query();
        //Scroll to the top of the results when a new page is chosen
        vm.location.hash("searchTop");
        vm.anchorScroll();
        vm.defaultState = false;
        vm.clearAllSetFlag();
    };

    vm.updateTime = function (filter) {
        if (filter === 'custom') return;
        vm.searchService.getFilter('page').setValue('1');
        var routeBuilder = this.searchService.getRouteBuilder();
        if (filter == "all") {
            vm.clearDateRange();
        }
        var hash = {};
        var urlQuery = "&";
        var h = decodeURIComponent(routeBuilder.getRoute()).split("&");
        for (var idx in h) {
            if (h[idx] != "") {
                var currentParameter = h[idx].split("=");
                if (currentParameter[0] == "dateFilterLabel") {
                    hash[currentParameter[0]] = vm.timesObject[filter].id;
                    urlQuery = urlQuery + "&" + currentParameter[0] + "=" + vm.timesObject[filter].id;
                } else {
                    if (currentParameter[0] != "date") {
                        hash[currentParameter[0]] = currentParameter[1];
                        urlQuery = urlQuery + "&" + currentParameter[0] + "=" + currentParameter[1];
                    }
                }
            }
        }
        //Ignore date filter (querystrings) if All option is selected.
        if (filter != "all") {
            hash["time"] = vm.timesObject[filter].value;
            urlQuery = urlQuery + "&time=" + vm.timesObject[filter].value;
        }

        if (vm.companies["isCompanySelected"]) {
            hash["companies"] = vm.companies["companies"];
        }

        if ("companies" in hash) {
            vm.isCompanySelected = true;
            hash["companies"] = hash["companies"].replace(/%20/g, " ").replace(/%3B/g, ';');
            vm.companies["companies"] = hash["companies"].replace(/%20/g, " ").replace(/%3B/g, ';');
        }
        vm.location.search(urlQuery);
        vm.searchService.queryTimePeriod(hash);
        //Scroll to the top of the results when a new page is chosen
        vm.location.hash("searchTop");
        vm.anchorScroll();
        vm.defaultState = false;
        vm.clearAllSetFlag();
    };

    vm.facetChange = function (facet) {
        vm.defaultState = false;
        vm.searchService.getFacetGroup(facet.parentId).getFacet(facet.id).selected = facet.selected;
        vm.selectAllFacet(facet, facet.parentId);
        vm.update(facet.parentId);
        if(vm.keywordSearch && vm.enableMySusbriptions)
           vm.updateCookie(facet.parentId);
        vm.clearAllSetFlag();
    };

    vm.clearFacetsInGroup = function (facetGroupId) {
        vm.defaultState = false;
        _.each(vm.searchService.getFacetGroup(facetGroupId).facets, function (facet) {
            facet.selected = false;
            vm.selectAllFacet(facet, facetGroupId);
        });
        vm.update(facetGroupId);
        if (vm.keywordSearch && vm.enableMySusbriptions)
            vm.updateCookie(facetGroupId);
        vm.clearAllSetFlag();
    };

	/*  
     *  facetGroupId: 'publication' 
     *  facetIds: ['In Vivo', 'Rose Sheet'] 
     */
    vm.facetChangeMultiple = function(facetGroupId, facetIds) {
        var facets,
            subfacets = [];
        if (facetIds.length > 0) {
            _.each(vm.facetGroups, function (group) {
                if (group.id === facetGroupId) {
                    facets = group;
                }
            });

            _.each(facets.getSelectedFacets(), function (facet) {
                if (facet) {
                    facet.selected = false;
                }
            });

            _.each(facetIds, function (id) {
                var pubFacets = facets.facets;
                var splitName = id.split("-");
                if (splitName.length > 1) {
                    id = splitName[0];
                }
                _.each(pubFacets, function (pubFac) {
                    var facetId = pubFac.id.replace(" ", "").replace("'", "").toLowerCase();
                    if(facetId === id.replace(" ", "").replace("'", "").toLowerCase()) {
                        pubFac.selected = true;
                    }
                })
            });

            _.each(facetIds, function (id) {
                var splitName = id.split("-");
                if (splitName.length > 1) {
                    var parentId = splitName[0].replace(" ", "");
                    var myId = splitName[1].replace("and", "&");
                    _.each(vm.facetGroups, function (group) {
                        if (group.id == parentId) {
                            subfacets = group.facets;
                        }
                    });

                    _.each(subfacets, function (subfac) {
                        if (subfac.id.toLowerCase() == myId.toLowerCase()) {
                            subfac.selected = true;
                        }
                    });
                }
            });

            if(vm.enableMySusbriptions && vm.keywordSearch)
                vm.createCookie(vm.subscriber_cookie,facetIds,3650);

            vm.update();
            vm.clearAllSetFlag();
        } else {
            vm.clearAllFacets();
        }
    };

    /* 
     * TODO: this comes from a diff search app, and needs jquery to work.
     * either hook up jq to this controller or move this elsewhere 
     */
    vm.scrollTop = function () {
        // var location = jq(".search-facets__header").offset().top;
        //window.scrollTo(0, location - 80);
    };

    vm.hasSelected = function (values) {
        return _.find(values, { selected: true }) ? true : false;
    };

    vm.getFilter = function (filterKey) {
        var filter = vm.searchService.getFilter(filterKey);
        if (!filter) {
            vm.searchBootstrapper.createFilter(filterKey, "");
            filter = vm.searchService.getFilter(filterKey);
        }
        return filter;
    };

    /* This deselects any selected facet checkboxes, clears all facet parameters
        from the search query, and runs the clearDateRange function */
    vm.clearAllFacets = function () {
        var facetClear = this;
        var facetGroups = facetClear.facetGroups;
        _.each(facetGroups, function (group) {
           // var facets = vm.searchService.getFacetGroup(group.id).getSelectedFacets();
            var facets = group.facets;
            _.each(facets, function (facet) {
                facet.selected = false;
                _.each(facet.sublist, function (subFacetitem) {
                    subFacetitem.selected = false;
                });
            });
        });
        vm.clearDateRange();
        vm.update();
        if(vm.keywordSearch && vm.enableMySusbriptions)
             vm.createCookie(vm.subscriber_cookie, [], 3650);

        vm.clearAllVisible = false;
    };
    /**
     * Function to set state of clearallVisible flag
     */
    vm.clearAllSetFlag = function(){
        if(!vm.themeOmdia){
            return;
        }
        var facetClear = this;
        var isAnyfacetSelected = false;

        var facetGroups = facetClear.facetGroups;
        _.each(facetGroups, function (group) {
            var facets = group.facets;
            _.each(facets, function (facet) {
                if (facet.selected) {
                    isAnyfacetSelected = true;
                    return;
                } else {
                    var facetSublist = facet.sublist;
                    _.each(facetSublist, function (childFacet) {
                        if (childFacet.selected) {
                            isAnyfacetSelected = true;
                            return;
                        }
                    });
                }
            });
        });
        vm.clearAllVisible = isAnyfacetSelected;
    };

    /* *
     * Check if search returned any record.
     * */
    vm.hasResults = function () {
        var hasRecordsToDisplay = false;
        var facetClear = this;

        var facetGroups = facetClear.facetGroups;
        _.each(facetGroups, function (group) {
            var facets = group.facets;
            _.each(facets, function (facet) {
                if (facet.count > 0) {
                    hasRecordsToDisplay = true;
                    return;
                }
            });
        });
        return hasRecordsToDisplay;
    };

    vm.clearFilter = function (filterKey) {
        var filter = vm.getFilter(filterKey);
        filter.setValue("");
    };

    /* This clears the date parameters from the search, deselcts any date radio
    buttons, and clears both custom date input fields **/
    vm.clearDateRange = function () {
        var filter = vm.getFilter('date');
        filter.setValue("");
        filter.selected = false;
        var filterDateLabel = vm.getFilter('dateFilterLabel');
        filterDateLabel.setValue("");
        var dates = vm.DateFilters;
        _.each(dates, function (date) {
            if (date.key == "all")
                date.selected = true;
            else
                date.selected = false;
        });
        $scope.dateValues.dtFrom = "";
        $scope.dateValues.dtTo = "";
    };

    vm.getDateFilterLabel = function () {
        var filterDateLabel = vm.getFilter('dateFilterLabel');
        return filterDateLabel._value;
    };

    vm.searchForCompany = function (selectedCompany) {
        /* 
         * This is not correct right now, should be using facet groups instead will fix later 
         */
        var facets = vm.searchService.getFacetGroup('companies').getSelectedFacets();

        var filter = vm.getFilter('companies');

        var companyFilter = selectedCompany;
        var sep = ';';

        for (var i = 0; i < facets.length; i++) {
            companyFilter += sep + facets[i].id;
        }

        filter.setValue(companyFilter);

        vm.update();
    };


    vm.validateFormat = function (date, type) {
        if(date == undefined)
            alert("The '"+type+"' date value isn't properly formatted");
    };


    vm.customDateRangeSearch = function (filterKey, startDate, endDate, sourceControl) {

        var filter = vm.getFilter(filterKey);
        var filterDateLabel = vm.getFilter('dateFilterLabel');
        filterDateLabel.setValue('custom');

        if(startDate > new Date()){
            alert("From date can not be greater than today");//  you can't select date bigger than today");
            $scope.dateValues.dtFrom = "";
        }

        if(endDate > new Date()){
            alert("To date can not be greater than today");//
            $scope.dateValues.dtTo = "";
        }

        if (startDate > 0 && endDate > 0 && startDate <= endDate) {
            var date1Unparsed = new Date(startDate);
            var date1 = (date1Unparsed.getMonth() + 1) + '/' + date1Unparsed.getDate() + '/' + date1Unparsed.getFullYear();

            var date2Unparsed = new Date(endDate);
            var date2 = (date2Unparsed.getMonth() + 1) + '/' + date2Unparsed.getDate() + '/' + date2Unparsed.getFullYear();

            filter.setValue(date1 + ";" + date2);

            vm.update();
        } else if (startDate > 0 && vm.themeChemistAndDruggist && startDate <= new Date() && endDate == "") {
            var date1Unparsed = new Date(startDate);
            var date1 = (date1Unparsed.getMonth() + 1) + '/' + date1Unparsed.getDate() + '/' + date1Unparsed.getFullYear();

            var date2Unparsed = new Date(endDate);
            var date3Unparsed = new Date();

            var date3 = (date3Unparsed.getMonth() + 1) + '/' + date3Unparsed.getDate() + '/' + date3Unparsed.getFullYear();
            var date2;

            if (date2Unparsed instanceof Date && !isNaN(date2Unparsed.valueOf())) {
                date2 =  (date2Unparsed.getMonth() + 1) + '/' + date2Unparsed.getDate() + '/' + date2Unparsed.getFullYear();
            } else {
                date2 =  date3;
            }

            filter.setValue(date1 + ";" + date2);

            vm.update();
        } else {
             if( (startDate!="" && startDate != undefined) && (endDate!="" && endDate!=undefined) ){
                if(startDate > endDate){
                    alert("From date can not be greater than To date");//  You cant put 'from' date bigger than 'to' date");
                    if(sourceControl == 'from') {
                        $scope.dateValues.dtFrom = "";
                    } else {
                        $scope.dateValues.dtTo = "";
                    }
                }
            }
        }
    };

    $scope.options = {
        showWeeks: false
    };

    //** This builds date parameters for the search query **//
    vm.dateRangeSearch = function (filterKey, dateFilter) {
        var filter = vm.getFilter(filterKey);
        var filterDateLabel = vm.getFilter('dateFilterLabel');

        var startDate = vm.datesObject[dateFilter];
        var endDate = formatDateObject(new Date());

        $scope.dateValues.dtFrom = "";
        $scope.dateValues.dtTo = "";

        filterDateLabel.setValue(dateFilter);
        filter.setValue(startDate + ";" + endDate);

        vm.updateSelectedDate(dateFilter);
        vm.updateTime(dateFilter);
        //vm.update();
    };

    vm.updateSelectedDate = function (dateFilter) {

        for (var i = 0; i < vm.DateFilters.length; i++) {
            if (dateFilter == vm.DateFilters[i].key) {

                vm.DateFilters[i].selected = true;

            } else {

                vm.DateFilters[i].selected = false;

            }
        }
    };

    vm.allRegionsFacetsSelected = function() {
        var facetList = this,
            facetGroups = facetList.facetGroups;

            if (vm.themeOmdia) {
              // loop all facets
                _.each(facetGroups, function(group) {
                    var facets = group.facets;
                    _.each(facets, function(facet) {

                      // if facet group is regions or service area
                        if (facet.parentId === 'regions' || facet.parentId === 'servicearea') {

                            if (facet.sublist && facet.sublist.length === 0 && facet.selected) {
                                return;
                            }

                            // vm.allSubFacetSelected = true, if any of the sublist items selected
                            var allRegionsFacetsSelected = facet.sublist && facet.sublist.length > 0 ? 
                                facet.sublist.every(function(itm){ return itm.selected; }) : false;
                            vm.allSubFacetSelected = allRegionsFacetsSelected;

                            // then select parent facet of sublist
                            if (allRegionsFacetsSelected) {
                                facet.selected = true;
                                vm.ParentFacetId =  facet.parentId;
                            } else {
                                facet.selected = false;
                            }
                        }
                    });
                });
            }
    };

    vm.selectAllFacet = function(facet, facetId) {
        var facetList = this,
            facetGroups = facetList.facetGroups;

        if(vm.themeOmdia && facet && (facetId === 'regions' || facetId === 'servicearea') && facet.sublist.length) {
            var regionsfacetIndex = facetGroups.findIndex(function (element) {
                return element.id === facetId;
            });
            var selectedFacetIndex = facetGroups[regionsfacetIndex].facets.findIndex(function (element) {
                return element.id === facet.id;
            });
            _.each(facetGroups[regionsfacetIndex].facets[selectedFacetIndex].sublist, function(sublist) {
                sublist.selected = facet.selected;
            });
        }
    };

    vm.getFacetGroupState = function (group) {
        // Code to Expand refinements based on CMS configuration. (first time only)
        if (vm.defaultExpandedRefinements && vm.defaultExpandedRefinements !== "") {
            vm.defaultExpandedRefinements.split(',').forEach(function(element) {
                vm.facetgroupState[element] = false;
            });
            // set to null for "first time only"
            vm.defaultExpandedRefinements = null;
        }
        if (!vm.defaultState && jQuery('#persistUserState').val() == "false" ) { return false; }
        
        // set the new property to true if defaults has values (defaults are already set to false)
        if (vm.facetgroupState[group.id] === undefined) {
            vm.facetgroupState[group.id] = jQuery('#defaultExpandedRefinements').val() != "";
        }

        // set facetgroupState for group where one facet/subfacet is selected
        // this expands the UI for the respective facet group 
        _.each(vm.searchService.getFacetGroup(group.id).facets, function(facet) {
            if (facet.selected) {
                // console.log('facet', facet.id);
                vm.facetgroupState[group.id] = false;
                return true;
            }
            _.each(facet.sublist, function(subFacet) {
                if (subFacet.selected) {
                    // console.log('subFacet', subFacet.id);
                    vm.facetgroupState[group.id] = false;
                    return true;
                }
            });
        });

        return vm.facetgroupState[group.id];
    };

    vm.isPartialSelectedfacetGroup = function (group) {
        if (!vm.themeOmdia)
            return false;
        if (group && (group.parentId === 'regions' || group.parentId === 'servicearea') && group.sublist.length) {
            var facets = group.sublist;
            var selectedCount = 0;
            var unSelectedCount = 0;
            _.each(facets, function (facet) {
                if (facet.selected) {
                    selectedCount++;
                } else {
                    unSelectedCount++;
                }
            });
            return unSelectedCount > 0 && selectedCount > 0;
        }
        return false;
    };

    vm.updateFacetToggleState = function () {
        var facetShowMore = this;
            var facetGroups = facetShowMore.facetGroups;
            _.each(facetGroups, function (group) {
                if(group.ShowMore) {
                    vm.facetWithShowMore.push(group.id)
                }
                var facets = group.facets;
            _.each(facets, function (facet) {
                if(group.ShowMore) {
                    vm.subFacetWithShowMore.push(facet.id)
                }
            });
        });
    };
};

var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("InformaFacetController", ['$scope', '$rootScope', '$location', '$http', '$anchorScroll', '$timeout', 'searchService', 'searchBootstrapper', 'facetAvailabilityService', InformaFacetController]);